exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StyleEditor___1RvzE {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  padding: 0.25rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.HeaderRow___xyA6t {\n  display: flex;\n  align-items: center;\n}\n\n.Header___2SGfE {\n  flex: 1 1;\n}\n\n.Brackets___2zA4K {\n  font-family: var(--font-family-sans);\n  font-size: var(--font-size-sans-small);\n}\n\n.Row___3v8mp {\n  white-space: nowrap;\n  padding-left: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.Invalid___3ogBH {\n  background-color: var(--color-background-invalid);\n  color: var(--color-text-invalid);\n\n  --color-border: var(--color-text-invalid);\n}\n.Attribute___2yC0c {\n  color: var(--color-attribute-name);\n}\n\n.Value___1yJUg {\n  color: var(--color-attribute-value);\n}\n\n.Input___3Zdnf {\n  flex: 0 1 auto;\n  padding: 1px;\n  box-shadow: 0px 1px 3px transparent;\n}\n.Input___3Zdnf:focus {\n  color: var(--color-text);\n  box-shadow: 0px 1px 3px var(--color-shadow);\n}\n\n.Empty___3Pi3w {\n  color: var(--color-dimmer);\n  font-style: italic;\n  user-select: none;\n  padding-left: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"StyleEditor": "StyleEditor___1RvzE",
	"HeaderRow": "HeaderRow___xyA6t",
	"Header": "Header___2SGfE",
	"Brackets": "Brackets___2zA4K",
	"Row": "Row___3v8mp",
	"Invalid": "Invalid___3ogBH",
	"Attribute": "Attribute___2yC0c",
	"Value": "Value___1yJUg",
	"Input": "Input___3Zdnf",
	"Empty": "Empty___3Pi3w"
};